import { LOCALE_ID, Provider } from "@angular/core";
import { LocalizationService } from "./localization.service";

export const LocalizationProvider: Provider = {
    provide: LOCALE_ID,
    useFactory: (localizationService: LocalizationService) => {
        return localizationService.getLanguage();
    },
    deps: [LocalizationService]
};